import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const OurCompanyContent = (props) => {
  const {t} = useTranslation();
  const {data} = props;

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  return (
    <div>
      <div className="row">
        <div className="col-10 offset-1">
          <p className="corporation-name jp-bold-600">{t("about_isn.company_overview_page.what_is_flesta.txt_introdure")}</p>
        </div>
      </div>
      {data && data.length
        ? data.slice(0, 5).map((item, index) => (
          <div className="row" key={index}>
            <div className="col-2 col-md-1"></div>
            <div className="col-10 col-md-11 company-feature-block" key={index}>
              <div className="company-feature-image">
                <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`} className="h-100 w-100" alt="" />
                {/* <LazyLoadImage src={IconOutCompany[`company${index + 1}`]} alt="" effect="blur" /> */}
              </div>
              <div className="company-feature">
                <div className="feature-title jp-bold-600">{item.title}</div>
                <hr className="feature-line" />
                <div className="feature-description jp-font-sawarabi-gothic" dangerouslySetInnerHTML={createMarkup(item.content)}></div>
              </div>
            </div>
            </div>
          ))
        : ''}{' '}
    </div>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OurCompanyContent);
